import { Icon, Text } from "@alpacahq/ui/old";

import type { UseGetAllRelationshipsReturn } from "~/v2/api/hooks/useGetAllRelationships";
import { FAQ } from "../../../components/common/FAQ";
import { BankIcon, DepositIcon, WithdrawIcon } from "./common/icons";
import { Layout } from "./common/Layout";
import { GENERAL_FAQ } from "./faq";
import { LinkedAccounts } from "./LinkedAccounts";

export interface FundingHomePresentationProps {
  accountID: string;
  relationships: UseGetAllRelationshipsReturn;
  showWithdraw: boolean;
  onDepositClicked: () => void;
  onWithdrawClicked: () => void;
  onPortfolioTransferClicked: () => void;
}

export const FundingHomePresentation = ({
  accountID,
  relationships,
  showWithdraw,
  onDepositClicked,
  onWithdrawClicked,
  onPortfolioTransferClicked,
}: FundingHomePresentationProps) => (
  <Layout
    title="Transfer Funds"
    subtitle="Deposit and withdraw funds to and from your Alpaca account."
    className="p-2"
    faq={<FAQ faq={GENERAL_FAQ} />}
  >
    <div className="px-2">
      <Text className="pb-4 font-semibold text-xl">Transfers</Text>
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-4">
          <div className="flex gap-4">
            <button
              type="button"
              className="flex h-20 w-full max-w-lg items-center gap-2 rounded border px-4 transition hover:border-black"
              onClick={onDepositClicked}
            >
              <div className="flex grow items-center gap-2">
                <DepositIcon />
                Deposit
              </div>
              <Icon name="ChevronRight" />
            </button>
            {showWithdraw && (
              <button
                type="button"
                className="flex h-20 w-full max-w-lg items-center gap-2 rounded border px-4 transition hover:border-black"
                onClick={onWithdrawClicked}
              >
                <div className="flex grow items-center gap-2">
                  <WithdrawIcon />
                  Withdraw
                </div>
                <Icon name="ChevronRight" />
              </button>
            )}
          </div>
          <button
            type="button"
            className="flex w-full items-center gap-2 rounded border px-4 py-6 transition hover:border-black"
            onClick={onPortfolioTransferClicked}
          >
            <div className="flex items-center gap-3">
              <BankIcon />
              <div className="flex flex-col items-start gap-1">
                <Text className="text-start">Transfer your portfolio in</Text>
                <Text className="text-start font-medium text-green-500 text-sm">
                  Transfer $30,000 or more and get a reduced margin rate for 6
                  months.
                </Text>
              </div>
            </div>

            <Icon name="ChevronRight" />
          </button>
        </div>
        <LinkedAccounts accountID={accountID} relationships={relationships} />
      </div>
    </div>
  </Layout>
);
